// Razorpay Checkout helper — loads checkout.js on demand and runs the pay flow.
// Works for logged-in clients and public visitors (order endpoint handles access).
import api from "./api";

let checkoutLoading = null;

function loadCheckout() {
  if (window.Razorpay) return Promise.resolve();
  checkoutLoading =
    checkoutLoading ||
    new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "https://checkout.razorpay.com/v1/checkout.js";
      s.onload = resolve;
      s.onerror = () => reject(new Error("Could not load the Razorpay checkout — check your internet and retry"));
      document.body.appendChild(s);
    });
  return checkoutLoading;
}

export function inr(paise) {
  return `₹${((paise || 0) / 100).toLocaleString("en-IN")}`;
}

export async function payItem(item, { onPaid } = {}) {
  const cfg = await api.get("/payments/config");
  if (!cfg.data.configured) {
    throw new Error("Payments are not configured yet — the admin needs to add the Razorpay keys first");
  }
  const order = await api.post("/payments/order", { item_id: item.id });
  await loadCheckout();
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: order.data.key_id,
      amount: order.data.amount,
      currency: "INR",
      name: "Dreams Soft Solutions Pvt. Ltd.",
      description: item.title,
      order_id: order.data.order_id,
      theme: { color: "#0e7490" },
      handler: async (resp) => {
        try {
          await api.post("/payments/verify", {
            order_id: resp.razorpay_order_id,
            payment_id: resp.razorpay_payment_id,
            signature: resp.razorpay_signature,
          });
          if (onPaid) onPaid();
          resolve();
        } catch (e) {
          reject(e);
        }
      },
      modal: { ondismiss: () => reject(new Error("Payment cancelled")) },
    });
    rzp.open();
  });
}
